<template>
    <div>

        <!-- Preview -->

        <trax-setting-background-preview :bus="bus" :id="id">
        </trax-setting-background-preview>

        <!-- Table -->

        <trax-ui-card-plain-header-with-actions :title="title" :actions="card_actions" :bus="bus">
            <trax-setting-background-crud-table :bus="bus" :id="id" :endpoint="endpoint">
            </trax-setting-background-crud-table>
        </trax-ui-card-plain-header-with-actions>

        <!-- Editing modal -->

        <trax-ui-modal-default :id="id+'-edit'" :bus="bus">
            <trax-setting-background-crud-form :bus="bus" :id="id+'-edit'" :toastr-id="id+'-toastr'"
                :preview-id="id+'-preview'" :endpoint="endpoint">
            </trax-setting-background-crud-form>
        </trax-ui-modal-default>

        <!-- Toastr -->

        <trax-ui-toastr :id="id+'-toastr'" :bus="bus" passed-label="1" no-progress="1">
        </trax-ui-toastr>

    </div>
</template>

<script>
    export default {

        props: {
            id: null
        },

        data: function() {
            return {
                lang: lang,
                endpoint: app_url+"polaris/api/front/backgrounds",
                card_actions: [
                    { icon: 'add_box', event: this.id+'-edit-create' }
                ],
                bus: new Vue()
            }
        },

        computed: {

            title() {
                return this.lang.polaris.settings.backgrounds;
            }
        }

    }
</script>
